module.exports = __webpack_public_path__ + "static/img/工业.2727b9cd.png";